export default __webpack_public_path__ + "static/media/12_AOV_PANDA.72f284c6.webm";